import dynamicArticleContentConfig, {
  type IDynamicComponentConfig,
} from '../../configs/dynamic.components.config';
import _Error from '~/components/content/_Error.vue';

export default function useDynamicComponent(
  collection: string,
): IDynamicComponentConfig | undefined {
  // @ts-expect-error dynamic key in object
  const dynamicComponentDefinition = dynamicArticleContentConfig[collection];

  return {
    component: dynamicComponentDefinition?.component
      ? dynamicComponentDefinition.component
      : _Error,
    fields: dynamicComponentDefinition?.fields,
    props: dynamicComponentDefinition?.props,
    noData: dynamicComponentDefinition?.noData,
  };
}
